'use es6';

import { createContext } from 'react';
const InpageContext = /*#__PURE__*/createContext({});
export default InpageContext;